import { FILES_HOST } from '@shared/config/assets';

import { FOOTER_EMAIL, FOOTER_PHONE_TEL } from '@components/Footer/FooterMenuAndContacts/constants';

import { RequisitesSectionProps } from './components/RequisitesSection/types';
import { CityOfficeBlock, ContactAudienceCard } from './types';

export const CONTACT_PAGE_TITLE = 'Контакты';
export const CONTACTS_IMAGES_BASE_URL = `${FILES_HOST}/contacts`;

export const CONTACT_AUDIENCE_CARDS: ContactAudienceCard[] = [
    {
        id: 'buyers',
        title: 'Для покупателей',
        schedule: 'ПН – ПТ с 8:00 до 18:00 МСК',
        phoneLabel: '8 (800) 444-35-00 (доб.2)',
        phoneTel: FOOTER_PHONE_TEL,
        email: FOOTER_EMAIL,
    },
    {
        id: 'suppliers',
        title: 'Для поставщиков',
        schedule: 'ПН – ПТ с 8:00 до 17:00 МСК',
        phoneLabel: '8 (800) 444-35-00 (доб. 002-801)',
        phoneTel: FOOTER_PHONE_TEL,
        email: 'zakup@layta.ru',
    },
    {
        id: 'marketing',
        title: 'Маркетинг и реклама',
        schedule: 'ПН – ПТ с 8:00 до 17:00 МСК',
        phoneLabel: '8 (800) 444-35-00 (доб. 002-416)',
        phoneTel: FOOTER_PHONE_TEL,
        email: 'pr@layta.ru',
    },
];

const REGIONAL_PHONE_LABEL = '8 (800) 444-35-00 (доб.2)';
const REGIONAL_PHONE_TEL = FOOTER_PHONE_TEL;
const REGIONAL_SCHEDULE = 'ПН - ПТ, 9:00-18:00';

export const CITY_OFFICES: CityOfficeBlock[] = [
    {
        id: 'moscow',
        label: 'Москва',
        sales: {
            title: 'Отдел продаж в г. Москва',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Москва, ул. Рябиновая, д.45а, стр.24',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'msk@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3A8db391d77c5d60639b228bb41c4555c425db754bb854fd527d328c9064088805&source=constructor',
        },
        warehouse: {
            title: 'Склад в г. Москва',
            schedule: REGIONAL_SCHEDULE,
            address: 'ИЛЦ Внуково 2, корпус 11. Москва поселение Марушкинское, квартал № 63, 1А, стр. 1',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'msk@layta.ru',
            routeSchemeUrl: '/scheme-ilc-vnukovo-2-line-v-block-11.pdf',
        },
    },
    {
        id: 'spb',
        label: 'Санкт-Петербург',
        sales: {
            title: 'Отдел продаж в г. Санкт-Петербург',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Санкт-Петербург, Лиговский проспект д.123 БЦ Андрин, 3 этаж вход со стороны Воронежской улицы',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'spb@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3A11063a60f7d46fd292c301637fb1bb40d6a9519b457ea339e7b55ae690c30597&source=constructor',
        },
        warehouse: {
            title: 'Склад в г. Санкт-Петербург',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Санкт-Петербург, ул. Седова, д. 10, лит. А; В',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'spb@layta.ru',
        },
    },
    {
        id: 'voronezh',
        label: 'Воронеж',
        sales: {
            title: 'Отдел продаж в г. Воронеж',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Воронеж, ул. Урицкого, д. 151 БЦ «Гравитация», 3 этаж',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'voronezh@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3A7fe6db1c5590a369fa29b9daf6e1f58b4fb187f5deb970a92426bf6d7ed6ebf4&source=constructor',
        },
    },
    {
        id: 'kazan',
        label: 'Казань',
        sales: {
            title: 'Отдел продаж в г. Казань',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Казань, 2 Азинская 1а, офис 12',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'kazan@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3A8f05e69d062e715065b547d9fee21b548729a69d91b08b2fcd2f0320489a0f08&source=constructor',
        },
    },
    {
        id: 'saratov',
        label: 'Саратов',
        sales: {
            title: 'Отдел продаж в г. Саратов',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Саратов, ул. Ульяновская, д. 28',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'saratov@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3A750f045ff4c1e26ea667febb1efbe98e4fb82cb77e1eed5352ed7bec3394f3d7&source=constructor',
        },
        warehouse: {
            title: 'Склад в г. Саратов',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Саратов, ул. Ст. Трофимовский – 2, «тер. комплекса Рубеж-Логистик», Ангар №3',
            phoneLabel: '8 (845) 273-55-75',
            phoneTel: '+78452735575',
            email: 'saratov@layta.ru',
        },
    },
    {
        id: 'samara',
        label: 'Самара',
        sales: {
            title: 'Отдел продаж в г. Самара',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Самара, ул. Партизанская, д. 86 (БЦ Партизан), оф. 217',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'samara@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3Ab11648d338282cf523a7b2832a7f271883fe10ca8023f084405ca9d9212c400b&source=constructor',
        },
    },
    {
        id: 'nizhny-novgorod',
        label: 'Нижний Новгород',
        sales: {
            title: 'Отдел продаж в г. Нижний Новгород',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Нижний Новгород, ул. Белинского, д. 38, оф. 15',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'nizhnynovgorod@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3Ab907803a4c9f6e5b761753a9f1c53a2e9452bcc4fb250c5c112e2833fa5b10bd&source=constructor',
        },
    },
    {
        id: 'ufa',
        label: 'Уфа',
        sales: {
            title: 'Отдел продаж в г. Уфа',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Уфа, ул. Маршала Жукова, д. 22, офис 107',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'ufa@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3A4174720e8a5a0c9be9bce2b6c3ba178185e08b38ade931377be0109f799e8fe1&source=constructor',
        },
    },
    {
        id: 'krasnodar',
        label: 'Краснодар',
        sales: {
            title: 'Отдел продаж в г. Краснодар',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Краснодар, ул. Рашпилевская 224, оф. 8 (4-й этаж)',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'krasnodar@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3Ab65f1e6b24eefe3f8cd4ebdd0a0d539586724503f9cfdc57a090d2ea3a7f531b&source=constructor',
        },
        warehouse: {
            title: 'Склад в г. Краснодар',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Краснодар, ул. Текстильная 9/9, корпус 2',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'krasnodar@layta.ru',
        },
    },
    {
        id: 'rostov-on-don',
        label: 'Ростов-на-Дону',
        sales: {
            title: 'Отдел продаж в г. Ростов-на-Дону',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Ростов-на-Дону, проспект Нагибина 40Б, офис 322А',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'rostov@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3A6c392e8e41052475ca9e1394e886ec3a8d5b78d2705079d09b650418d4b5575c&source=constructor',
        },
        warehouse: {
            title: 'Склад в г. Ростов-на-Дону',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Ростов-на-Дону, ул. Саратовская, 36',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'rostov@layta.ru',
        },
    },
    {
        id: 'simferopol',
        label: 'Симферополь',
        sales: {
            title: 'Отдел продаж в г. Симферополь',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Симферополь, проспект Победы 209М',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'simferopol@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3A518f02557d9666326e03ea9e2c50e442c85d6f493137ec1b8991a25fd4b631fe&source=constructor',
        },
        warehouse: {
            title: 'Склад в г. Симферополь',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Симферополь, ул. Жени Дерюгиной, дом № 10',
            phoneLabel: '8 (365) 288-82-09',
            phoneTel: '+73652888209',
            email: 'simferopol@layta.ru',
        },
    },
    {
        id: 'stavropol',
        label: 'Ставрополь',
        sales: {
            title: 'Отдел продаж в г. Ставрополь',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Ставрополь, ул. Пирогова 20 "А"',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'stav@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3Ac349a106f632d9c3d5626053f1720e9dcdbb739b78153dfed14f889174c2e440&source=constructor',
        },
        warehouse: {
            title: 'Склад в г. Ставрополь',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Ставрополь, 1-ая промышленная 24А',
            phoneLabel: '8 (961) 474-39-36',
            phoneTel: '+79614743936',
            email: 'stav@layta.ru',
        },
    },
    {
        id: 'ekaterinburg',
        label: 'Екатеринбург',
        sales: {
            title: 'Отдел продаж в г. Екатеринбург',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Екатеринбург, ул. Сибирский тракт 12, стр. 8',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'ekb@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3A9fc245e28644636ec05b2c906a25dd04fbd3e54fe0d1c14aa01b89ad5dc974e8&source=constructor',
        },
    },
    {
        id: 'krasnoyarsk',
        label: 'Красноярск',
        sales: {
            title: 'Отдел продаж в г. Красноярск',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Красноярск, ул. Авиаторов, 24',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'krasnoyarsk@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3Abc2d08779b6c23536f67982b77d144ea998ede0f09b26296425ae937d1c36755&source=constructor',
        },
    },
    {
        id: 'novosibirsk',
        label: 'Новосибирск',
        sales: {
            title: 'Отдел продаж в г. Новосибирск',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Новосибирск, ул. Добролюбова, 2а, офис 310, БЦ "Речной вокзал"',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'nsk@layta.ru',
            yandexMapWidgetSrc:
                'https://yandex.ru/map-widget/v1/?um=constructor%3A1d9aff2a3f5f94a5c29695951546e72597337e65af327fb54e8ddb249f0d3f84&source=constructor',
        },
        warehouse: {
            title: 'Склад в г. Новосибирск',
            schedule: REGIONAL_SCHEDULE,
            address: 'г. Новосибирск, ул. Авиастроителей, 30',
            phoneLabel: REGIONAL_PHONE_LABEL,
            phoneTel: REGIONAL_PHONE_TEL,
            email: 'nsk@layta.ru',
        },
    },
];

export const REQUISITES_CARD_LINES = [
    'Фактический адрес (офис): 410005, г. Саратов, ул. Большая Горная, д. 324, оф. 204 (2-й этаж)',
    'Почтовый адрес: 410056, г. Саратов, ул. Ульяновская, д. 28',
    'ИНН: 6454107010',
    'КПП: 645201001',
    'ОГРН: 1166451061369',
];

export const REQUISITES_SECTION_PROPS: RequisitesSectionProps = {
    companyTitle: 'ООО "ТехноЛайт"',
    lines: REQUISITES_CARD_LINES,
    sideTitle: 'Нужна помощь пресейл-инженера?',
    sideIntro: 'Для подготовки коммерческого предложения нам потребуется:',
    sideBullets: ['ваш запрос', 'адрес объекта', 'реквизиты', 'контактный мобильный телефон'],
    sideText: 'Укажите данные в теле письма и менеджер свяжется с Вами в ближайшее время.',
    sidePhoneLabel: '8 (800) 444-35-00 (доб.2)',
    sidePhoneTel: FOOTER_PHONE_TEL,
    sideEmail: FOOTER_EMAIL,
};
